import React from 'react';
import RadioSection from './RadioSection';
const YesNoOptions = ({ items, required }) => {
    const options = [];
    for (let i = 0; i < items.length; i++) {
        options.push(
            <div key={i} className="row">
                <div className={required ? 'col-sm-4 col-md-4 label-required' : 'col-sm-4 col-md-4'}>{items[i].title || items[i].name}</div>
                <div className="col-sm-6 col-md-5">
                    <RadioSection rowClass=" " name={items[i].name} items={window.osa.lookup.common.yesNoOptions} inline required={required} />
                </div>
            </div>
        );
    }
    return (
        <div className="form-group">
            {options}
        </div>
    );
};
export default YesNoOptions;